import React from 'react'
import { getAllClassNames } from 'helpers'
import styles from './TextInput.module.scss'

type TextInputProps = {
    label?: string
    isDisabled?: boolean
    typedValue?: string
    ariaLabel?: string
    onChange?: (code: string) => void
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

function TextInput({ onChange, isDisabled, ariaLabel, typedValue, onKeyDown }: TextInputProps) {
    return (
        <div>
            <form
                action=""
                className={getAllClassNames([
                    "ais-SearchBox-form",
                    styles.form,
                ])}
                noValidate
            >
                <input
                    aria-label={ariaLabel}
                    disabled={isDisabled}
                    className="ais-SearchBox-input"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck={false}
                    maxLength={25}
                    type="text"
                    value={typedValue}
                    onChange={(e: any) => onChange && onChange(e.target.value)}
                    onKeyDown={onKeyDown}
                />
                {/* <ResetButton
          hidden={
            query === undefined || query.length === 0 || bubbles.length > 0
          }
          onReset={onReset}
        /> */}
            </form>
        </div>
    )
}

export default TextInput